import CompoundTranslation from '@components/compound-translation';
import { Box } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

const ContainedBrandedImage = styled.img`
  max-width: 100%;
  max-height: 100px;
  margin-bottom: 20px;
  
  @media (max-width: 375px) {
    max-height: 50px;
  }
`;

export interface ContactLinkFooterProps {
    /**
     * Template string for the line displaying the link to contact the company
     */
    contactLineTemplate: string;
    /**
     * Text to display for the contact link
     */
    contactLinkText: React.ReactNode;
    /**
     * URL/Target when the contact link is clicked
     */
    contactLinkTarget: string;
    /**
     * Additional text to display underneath the contact link line
     */
    contactLines?: string[];
    /**
     * Source for the branding image in this footer
     */
    brandingImageSrc: string;
}

export const ContactLinkFooter = (props: ContactLinkFooterProps) => {
    const {
        contactLineTemplate,
        contactLinkText,
        contactLinkTarget,
        contactLines = [],
        brandingImageSrc
    } = props;

    return (
        <Box flexDirection='column'
             maxWidth={800}
             width='100%'
             margin='0 auto'
             padding='0 10px'
             flex='0 0 auto'
             display='flex'
             alignItems='flex-start'
             justifyContent='center'>
            <CompoundTranslation
                as='p'
                template={contactLineTemplate}
                data={[
                    <a key={0}
                       href={contactLinkTarget}>
                        {contactLinkText}
                    </a>
                ]}
            />
            {
                contactLines.map((line, index) => (
                    <p key={index}>{line}</p>
                ))
            }
            <Box alignSelf='center'
                 display='inline-flex'>
                <ContainedBrandedImage src={brandingImageSrc}/>
            </Box>
        </Box>
    );
};



// WEBPACK FOOTER //
// ./src/components/branding/contact-link-footer.tsx